import React from 'react';
import { Head, Label } from 'components/data-visualization/Table/SortingHead';
import Row from 'components/data-visualization/Table/Row';

import { Header } from './chartTable.style';

const ChartTableHeader: React.FC<{ isDaily: boolean }> = (props) => (
  <Head>
    <Row>
      <Header textAlign="center">
        <Label>Position</Label>
      </Header>
      <Header>
        <Label> </Label>
      </Header>
      <Header>
        <Label>Track</Label>
      </Header>
      <Header textAlign="center">
        <Label>Previous</Label>
      </Header>
      <Header textAlign="center">
        <Label>Peak</Label>
      </Header>
      <Header textAlign="center">
        <Label>{`${props.isDaily ? 'Days' : 'Weeks'} Active`}</Label>
      </Header>
      <Header textAlign="center">
        <Label>Streams</Label>
      </Header>
    </Row>
  </Head>
);

export default ChartTableHeader;
